import { getCookie } from "../utils/cookie";

/**
 * Hook to get the CSRF token from cookies.
 * Reads on every render (not once on mount) so that when the token cookie is set
 * shortly after load — e.g. mirrored from the backend on a split-domain deploy —
 * the next render (such as the user typing their email) picks it up.
 */
export function useCsrfToken(): string | null {
  return getCookie("csrftoken");
}

export default useCsrfToken;
